<template>
  <div class="table_card">
    <div class="table_card__head" style="padding: 35px 25px; position: relative;">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Eventos
          </p>
          <div class="work_calendar__header_buttons">
            <button
              class="faccess_button my-3"
              style="margin-left: 20px;"
              @click="$router.push({name: 'work_calendar'})">
              Calendario de eventos
            </button>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="provider_tasks">
      <div class="provider_tasks__wrapper">
        <span class="provider_tasks__wrapper--title">Próximos</span>

        <div class="provider_tasks__task_list">

          <div
            v-for="task in upcomingTasks"
            class="provider_tasks__task_container">
            <span class="provider_tasks__task_container--task_icon"></span>
            <div>
              {{ task.attributes.task_type }}
            </div>
          </div>

        </div>
      </div>

      <v-divider vertical></v-divider>

      <div class="provider_tasks__wrapper">
        <span class="provider_tasks__wrapper--title">Vencidos</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      current_date: new Date(),
      tasks: []
    }
  },
  methods: {
    getTasks(){
      try {
        this.$http.get('provider_tasks', {
          params: {
            company_id: this.getCompany().id
          },
          headers: {
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer '+this.getUserToken()
          }

        }).then(response => {
          this.tasks = response.body.data
          console.log(this.tasks)

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e){
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    }
  },
  computed:{
    upcomingTasks(){
      let arr = []
      this.tasks.forEach(task => {
        if(new Date(task.attributes.task_start.split('.')[0]) > this.current_date ||
           new Date(task.attributes.task_start.split('.')[0]).toLocaleDateString() == this.current_date.toLocaleDateString()){
            arr.push(task)
        }
      })
      return arr
    }
  },
  mounted(){
    this.getTasks()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/SGSST/provider_tasks/Index.vue